// Ineenos Bundles v1 (Ruslan B. 12.07.2025)
bundleApp = (function () {
  return {
    init: function () {
      bundleApp.setSectionBundles();
    },
    
    getBundles: async function() {
        const bundles = bundleApp.getCurrentBundles();
        const currProductID = document.querySelector('.js-bundle').getAttribute('data-product-id');

        async function fetchAndMergeProducts(bundles) {

          const productHandles = bundles.flatMap(item =>
            Object.values(item.products || {}).map(product => product.handle)
          );
      
          console.log('product-handles', productHandles);
      
          async function fetchProductByHandle(handle) {
            const shopDomain = '18d102.myshopify.com';
            const url = `https://${shopDomain}/products/${handle}.json`;
      
            try {
              const response = await fetch(url);
              if (!response.ok) {
                throw new Error(`Ошибка: ${response.statusText}`);
              }
              const data = await response.json();
              return data.product;
            } catch (error) {
              console.error('Error retrieving data:', error);
              return null;
            }
          }
      
          const productsData = await Promise.all(productHandles.map(handle => fetchProductByHandle(handle)));
          const resultArray = productsData.filter(product => product !== null);
          const mergedBundles = bundles.map(bundle => {
            const updatedProducts = Object.values(bundle.products || {}).map(product => {
              const matchingProductData = resultArray.find(productData => productData.id === Number(product.id));
              if (matchingProductData) {
                return { ...product, ...matchingProductData };
              }
              return product;
            });
      
            return { ...bundle, products: updatedProducts };
          });
      
          return mergedBundles;
        }
      
        try {
          const mergedBundles = await fetchAndMergeProducts(bundles);
          return mergedBundles;  
        } catch (error) {
          console.error('Error merging data:', error);
          return [];
        }
      },

    initToggler: function(){


      const bundleToggles = document.querySelectorAll('.js-bundle .js-bundle-toggle');

      bundleToggles.forEach(toggle => {
         toggle.addEventListener('change', () => {
            const isChecked = toggle.checked;
            const parent = toggle.closest('.js-bundle-item');
            console.log('parent',parent)

            // Внутри родителя: обработка .js-bundle-disable
            const inputsToDisable = document.querySelectorAll('.js-bundle-disable');
            console.log('inputsToDisable', inputsToDisable)
            inputsToDisable.forEach(input => {
            input.disabled = isChecked;
            });

            // Внутри родителя: обработка .js-bundle-enable
            const inputsToEnable = document.querySelectorAll('.js-bundle-enable');
             console.log('inputsToEnable', inputsToEnable)
            inputsToEnable.forEach(input => {
            input.disabled = !isChecked;
            });

            // По всей странице: скрыть или показать .js-bundle-hide
            const elementsToHide = document.querySelectorAll('.js-bundle-hide');
              console.log('elementsToHide', elementsToHide)
            elementsToHide.forEach(el => {
            el.style.display = isChecked ? 'none' : '';
            });
         });
      });



    },
    setSectionBundles: function () {
      const bundleContainer = document.querySelector('.js-bundle');
      const currProductID = bundleContainer.getAttribute('data-product-id');

      async function fetchAndDisplayBundles() {
        try {
          const bundles = await bundleApp.getBundles();

          bundles.forEach((bundle, index) => {

            console.log('curr bundle', bundle)
 
            const bundleSize = bundle.products.reduce((count, prod) => 
               count + (Number(prod.id) !== Number(currProductID) ? 1 : 0), 0
            );
            const bundleID = Number(bundle.id);
            const bundleDiscountNum = Number(bundle.percentage_value);
            const bundleOldPrice = bundle.products.reduce((sum, product) => {
               if (product.variants && product.variants.length > 0) {
               const firstVariantPrice = Number(product.variants[0].price) || 0;
               sum += firstVariantPrice;
               }
               return sum;
            }, 0);
            const bundlePrice = bundleOldPrice - ((bundleOldPrice / 100) * bundleDiscountNum);
            const bundleSavePrice = (bundleOldPrice - bundlePrice).toFixed(2);
        
            console.log('bundleOldPrice', bundleOldPrice);
            console.log('bundlePrice', bundlePrice);
            console.log('bundleDiscountNum', bundleDiscountNum);
            console.log('bundleSavePrice', bundleSavePrice);
        
            const bundleElement = document.createElement('div');
            bundleElement.classList.add('bundle__wrap');
            bundleElement.classList.add('js-bundle-item');
            bundleElement.setAttribute('data-bundle-id', bundle.id);
            bundleElement.setAttribute('data-discount', bundleDiscountNum);

            bundleElement.innerHTML = `
            <div class="bundle is-animate is-animate--slide-in" data-animate-cascade>
             <div class="bundle__content">
               <div class="bundle__switch">
                  <label class="c_inputSwitch" for="bundle-${index + 1}">
                  <input type="checkbox" name="bundle" id="bundle-${index + 1}" class="js-bundle-toggle"  value="${index + 1}">
                  <span class="c_inputSwitch__slider"></span>
                  </label>
               </div> 
               <div class="bundle__title">${bundle.title}</div>
               <div class="bundle__description">${bundle.description}</div>
               <div class="bundle__prices">
                  <div class="prices">
                  <div class="price price--old">€${bundleOldPrice}</div>
                  <div class="price price--default">€${bundlePrice}</div>
                  </div>
               </div> 
            </div> 
            </div> 
                `;
                bundleContainer.append(bundleElement);




               const bundleInputContainer = document.querySelector('.js-bundle-inputs');
               const bundleInputElement = document.createElement('div');
                bundleInputElement.innerHTML = `
                ${bundleSize > 0 ? bundle.products
                            .filter(prod => Number(prod.id) !== Number(currProductID)) 
                            .map((prod, idx) => `
                            <input class="js-bundle-enable" disabled="disabled" type="hidden" name="items[${idx + 1}][quantity]" value="1"> 
                                  <select class="none js-bundle-enable" disabled="disabled" name="items[${idx + 1}][id]">
                                    ${prod.variants && prod.variants.length > 0 ? prod.variants.map(variant => `
                                      <option data-price="${variant.price}" value="${variant.id}">${variant.title} - £${variant.price}</option>
                                    `).join('') : '<option>No options available</option>'}
                                  </select>
                          `).join('') : '<p>No products available</p>'}
                `;

         
            
            bundleInputContainer.append(bundleInputElement);




                
            bundleApp.initToggler();
          }); 

        } catch (error) {
          console.error('Error retrieving combined bundles', error);
        }
      }

      fetchAndDisplayBundles();
    },
  
   
    getCurrentBundles: function () {
      const bundlesData = window.bndlr.getBundles();
      const bundlesElement = document.querySelector('.js-bundle');
      const dataBundles = bundlesElement.getAttribute('data-bundles')?.split(',').map(name => name.trim()) || [];
      return bundlesData.filter(bundle => dataBundles.includes(bundle.name));
    }
  };
})();


 document.addEventListener('bundler:loaded', function(e) { 
       const bundlesElement = document.querySelector('.js-bundle'); 
       if(bundlesElement){ 
         bundleApp.init();
         console.log('bundles loaded') 
       }  
  });